<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Imprimir Inventário de Produtos</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body modal-print-container">
    @if (isLoading) {
    <div class="loading-container no-print">
      <app-loading-box width="100%" height="300px"></app-loading-box>
    </div>
    }

    @if (linhas.length > 0) {
    <div [hidden]="isLoading">
      <div class="table-responsive">
        <table mat-table [dataSource]="linhas">
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef style="width: 30%">Produto</th>
            <td mat-cell *matCellDef="let row" [class.local-cell]="row.isLocal">
              @if (row.isLocal) {
              <mat-icon class="local-icon">subdirectory_arrow_right</mat-icon>
              } @else if (row.isVariacao) {
              <span class="variacao-print">
                <mat-icon class="local-icon">subdirectory_arrow_right</mat-icon>
                {{ row.produto.descricao }}
              </span>
              } @else {
              {{ row.produto.descricao }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="codigoSku">
            <th mat-header-cell *matHeaderCellDef style="width: 13%">Código SKU</th>
            <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : (row.produto.codigoSku || '—') }}</td>
          </ng-container>

          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">Unidade</th>
            <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : (row.produto.unidade || '—') }}</td>
          </ng-container>

          <ng-container matColumnDef="preco">
            <th mat-header-cell *matHeaderCellDef style="width: 12%" class="text-end">Custo médio</th>
            <td mat-cell *matCellDef="let row" class="text-end">{{ row.isLocal ? '' : (row.produto.custoMedio | abnt:'preco') }}</td>
          </ng-container>

          <ng-container matColumnDef="localizacao">
            <th mat-header-cell *matHeaderCellDef style="width: 20%">Localização</th>
            <td mat-cell *matCellDef="let row">{{ getLocalizacao(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="saldoFisico">
            <th mat-header-cell *matHeaderCellDef style="width: 15%" class="text-end">Estoque atual</th>
            <td mat-cell *matCellDef="let row" class="text-end">{{ getSaldo(row) | abnt:'quantidade' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.local-row]="row.isLocal"
            [class.variacao-row]="row.isVariacao && !row.isLocal"></tr>
        </table>
      </div>
    </div>
    }

    @if (!isLoading && linhas.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!isLoading && linhas.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>